var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.container},[_c('img',{attrs:{"src":require("@assets/images/Zetrix-Logo.png"),"alt":"Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }